import { NavbarListButton } from '../Layout/NavbarListButton';
import { filterSameColor, iconButtonStyle, isLightColor } from '../../utils/styles';
import '../TextStylingComponent/ColorControl.css';

/* Icône par défaut : le « A » de la barre de style, rempli de la couleur en
   cours (cf. ColorControl.css). NavbarListButton ne sait teinter qu'un
   DuotoneLightIcon : les autres icônes portent la couleur elles-mêmes.
   « transparent » garde la lettre dans sa teinte d'origine, comme un duotone :
   remplie de transparent, elle disparaîtrait. */
const fontColorIcon = (color) => {
  const shown = color && color !== 'transparent' ? color : undefined;
  return (
    <p
      className={`font-color-indicator${isLightColor(shown) ? ' font-color-indicator--outlined' : ''}`}
      style={{ ...iconButtonStyle(), fontFamily: 'monospace', '--font-color-indicator': shown }}
    >
      A
    </p>
  );
};

/**
 * Choix d'une couleur dans la palette du document, au bouton de la barre de
 * style : la couleur en cours se lit dans l'icône, la palette s'ouvre au clic.
 *
 * `onChange` reçoit le *libellé* de la couleur choisie, comme les autres
 * sélecteurs de couleur du document.
 *
 * `colorInIcon` est passé tel quel à NavbarListButton : la couleur remplace la
 * couche grise du duotone par défaut, sa couche principale avec `'primary'`
 * (icône de bordure, dont le trait est la couleur réglée).
 */
export const ColorPaletteButton = ({
  title,
  icon,
  value,
  colors,
  onChange,
  disabled = false,
  disableTransparent = false,
  colorInIcon = true,
}) => (
  <NavbarListButton
    title={title}
    icon={icon ?? fontColorIcon(value?.style)}
    colorInIcon={colorInIcon}
    disabled={disabled}
    onListElementClick={onChange}
    listElements={filterSameColor(
      disableTransparent
        ? colors.filter((color) => color.label !== 'transparent')
        : colors
    )}
    selectedElement={value}
  />
);
